import { CanvasTexture, type Scene } from "three"
import { createOffscreenCanvas } from "../../canvas/create_canvas"
import { getCanvas2dContext } from "../../canvas/get_canvas_2d_context"

const SKY_GRADIENT_STOPS = [
  { offset: 0, color: "#ffe066" },
  { offset: 0.45, color: "#fc7f3f" },
  { offset: 0.75, color: "#9e1aff" },
  { offset: 1, color: "#05183a" },
]

function createGradientTexture(): CanvasTexture {
  const canvas = createOffscreenCanvas(256, 256)
  const ctx = getCanvas2dContext(canvas)

  if (ctx) {
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
    SKY_GRADIENT_STOPS.forEach(({ offset, color }) => gradient.addColorStop(offset, color))

    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, canvas.width, canvas.height)
  }

  const texture = new CanvasTexture(canvas)
  texture.needsUpdate = true
  return texture
}

export default function createGradientTextureSkyV2(scene: Scene): void {
  scene.background = createGradientTexture()
}
